import { makeApiCallWithAny } from "./tokenService";
import { IdTitle } from "../models/common/idTitle";
import { MyVehiclesResponseDto } from "../models/vehicle/vehicle";
import { EmployeeVehiclesUpsertDto } from "../models/vehicle/employeeVehicles";
import { ApiResponse, apiCall } from "./apiClient";

export const getVehicleIdTitles = (signal: AbortSignal): Promise<IdTitle[]> => {
    return makeApiCallWithAny("api/vehicle/idtitle", signal);
};

export const getMyVehicles = (
    signal: AbortSignal
): Promise<ApiResponse<MyVehiclesResponseDto>> => {
    return apiCall<MyVehiclesResponseDto>("vehicles/myvehicles", "GET", null, signal);
};

export const updateMyVehicles = (
    VehicleIds: EmployeeVehiclesUpsertDto,
    signal: AbortSignal
): Promise<ApiResponse<void>> => {
    return apiCall<void>("vehicles/myvehicles", "PUT", VehicleIds, signal);
};
